<template>
  <div class="page page-with-bg">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>Welcome!</h1>
        <div class="description">
          <p>
            At Precision Health Reports, we offer solutions to <br />
            address individual risk.
          </p>
          <p>
            Regardless of the analysis requested, we've made <br />
            the process of ordering, tracking, and viewing your <br />
            patient's reports streamlined and efficient.
          </p>
          <p>
            To get started, select your choice below.
          </p>
        </div>
        <div class="page-form-content">
          <div class="card-wrap">
            <b-card class="card-clickable client-card" @click="createReport">
              <svg-icon class="card-icon" name="orderanalysis"></svg-icon>
              <div class="card-title">Order an Analysis</div>
            </b-card>
            <b-card class="card-clickable client-card" @click="viewReports">
              <svg-icon class="card-icon" name="viewreports"></svg-icon>
              <div class="card-title">View Reports</div>
            </b-card>
            <b-card class="card-clickable client-card png-icon" @click="viewClientResources">
              <img src="../../../../Files/client-resource.png" />
              <div class="card-title">Client Resources</div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <client-select-modal v-if="isClientAdmin"
                         ref="clientSelectModal"
                         path="reports/create"
                         label="Select client for analysis order." />
  </div>
</template>

<script>
  import clientSelectModal from '@/components/common/modals/client-select-modal.vue';

  export default {
    components: { clientSelectModal },

    computed: {
      isClientAdmin() {
        return this.$auth.isInRole("ClientAdmin");
      }
    },

    methods: {
      createReport() {
        if (this.isClientAdmin) {
          this.$refs.clientSelectModal.show();

          return;
        }

        this.$router.push("reports/create");
      },

      viewReports() {
        this.$router.push("reports");
      },

      viewClientResources() {
        this.$router.push("information/client-resources")
      },
    }
  };
</script>

<style scoped lang="scss">
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/keyboard.png');
  }
</style>